// 作成代行データ関連のステータス
const initialState = () => ({
    selectType:"0",  // アクキーかアクスタか
    selectSize:"S",
    orderNum:1,
    usePurpose:"",
    remarks:"",
    sampleData:null,
    imageData:[],
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    reset(state) {
      Object.assign(state, initialState())
    },
    set(state, { key, value }) {
      if (key in state) {
        state[key] = value;
      }
    },
    addImageData(state, fileKit) {
      state.imageData.push(fileKit);
    },
    deleteImageData(state, index) {
      state.imageData.splice(index, 1);
    },
    setSampleDataDownloadUrl(state, url) {
      state.sampleData.downloadUrl = url;
    },
    setImageDataDownloadUrl(state, { index, url }) {
      state.imageData[index].downloadUrl = url;
    },
  },
}
